import { Link } from 'react-router-dom';

export default function HotSection() {
  return (
    <section id="hot" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-12 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-sm font-medium rounded-full mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              大家都在看
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-[400px]">
            精选全网最受欢迎的影视内容，每日根据播放量和用户评分实时更新热门榜单
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <Link
            to="/category/remen"
            className="group block rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20dark%20noir%20aesthetic%2C%20mysterious%20silhouette%20against%20city%20nightscape%2C%20dramatic%20lighting%20with%20warm%20amber%20tones%2C%20film%20grain%20texture%2C%20professional%20movie%20poster%20style%2C%20clean%20composition&width=800&height=500&seq=hot-video-01&orientation=landscape"
                alt="年度最佳悬疑大片《暗夜追踪》全网首播"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                  电影
                </span>
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                年度最佳悬疑大片《暗夜追踪》全网首播
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2">
                豆瓣评分8.9，年度必看悬疑力作，反转烧脑不容错过。
              </p>
            </div>
          </Link>

          <Link
            to="/category/remen"
            className="group block rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%20with%20city%20skyline%20at%20sunset%2C%20warm%20golden%20light%2C%20elegant%20aesthetic%2C%20emotional%20atmosphere%2C%20professional%20drama%20series%20key%20visual%2C%20soft%20bokeh%20background&width=800&height=500&seq=hot-video-02&orientation=landscape"
                alt="热门都市剧《繁华之下》第三季火热更新"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                  剧集
                </span>
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                热门都市剧《繁华之下》第三季火热更新
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2">
                全网播放量突破50亿，都市情感大戏持续热播中。
              </p>
            </div>
          </Link>

          <Link
            to="/category/remen"
            className="group block rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20poster%20with%20vibrant%20stage%20lights%2C%20cheerful%20atmosphere%2C%20entertainment%20show%20aesthetic%2C%20bright%20colorful%20spotlights%2C%20festive%20mood%2C%20clean%20professional%20composition&width=800&height=500&seq=hot-video-03&orientation=landscape"
                alt="现象级综艺《欢乐大本营》最新季回归"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <div className="absolute bottom-3 left-3">
                <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                  综艺
                </span>
              </div>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                现象级综艺《欢乐大本营》最新季回归
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2">
                原班人马全新出发，笑点密集，每周五晚准时更新。
              </p>
            </div>
          </Link>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/remen"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors cursor-pointer"
          >
            查看更多热门内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}